import { Image, TouchableOpacity, View } from "react-native";
import TextPrimary from "../../shared-components/text/TextPrimary";
import navigationNames from "../navigationNames";
import JutaAppIcon from "../../assets/icons/juta-app-icon.png";

interface HeaderLeftProps {
  onPress: (pageName: string, config?: object) => void;
}

const HeaderLeft = (props: HeaderLeftProps) => {
  return (
    <>
      <View
        style={{
          flexDirection: "row",
        }}
      >
        <TouchableOpacity
          onPress={() => {
            props.onPress(navigationNames.home.id, {});
          }}
        >
          <Image
            source={JutaAppIcon}
            style={{
              marginLeft: 16,
              width: 32,
              height: 32,
            }}
          />
        </TouchableOpacity>
      </View>
    </>
  );
};

export default HeaderLeft;
